<template>
  <div class="dashboard-container">
    
    <el-card shadow="never" class="filter-card">
      
      <el-row :gutter="20" align="middle">
        <el-col :xs="24" :sm="18">
          <el-button-group class="time-filters">
            <el-button 
              :type="activeTimeType === 'thisMonth' ? 'primary' : ''" 
              @click="setTime('thisMonth')">
              本月
            </el-button>
            <el-button 
              :type="activeTimeType === 'lastMonth' ? 'primary' : ''" 
              @click="setTime('lastMonth')">
              上個月
            </el-button>
            <el-button 
              :type="activeTimeType === 'custom' ? 'primary' : ''" 
              @click="setTime('custom')">
              指定時間
            </el-button>
          </el-button-group>
          
          <el-date-picker
            v-if="activeTimeType === 'custom'"
            v-model="activeTime"
            type="daterange"
            range-separator="至"
            start-placeholder="開始日期"
            end-placeholder="結束日期"
            style="margin-left: 10px; vertical-align: middle;"
          />
        </el-col>
        <el-col :xs="24" :sm="6" class="execute-button-col">
          <el-button type="success" @click="exportReport" style="margin-left: 8px;">
            匯出報表
          </el-button>
        </el-col>
      </el-row>
      <el-row :gutter="20" style="margin-top: 20px;">
        <el-col :span="24">
          <span 
            v-for="area in areafilters"
            :key="area.areaName"
          >
            <el-radio v-model="areafiltersSelection" :label="area.areaName" border>{{ area.areaName }}</el-radio>
          </span>
        </el-col>
      </el-row>
    </el-card>

    <el-card
      v-for="([frequency_unit, timeoutSettingMap], index) in timeoutSettingList" 
      :key="index"
      class="revenue-card"
      style="margin-top: 20px;"
    >
      <template #header>
        <div>
          <span>{{ $t(`frequencyCheck.${frequency_unit}`) }}</span>
        </div>
      </template>
      
      <div
        v-for="(timeoutSetting, index) in Array.from(timeoutSettingMap.values())" 
        :key="index"
        class="instrument-list"
      >
        <div class="instrument-header">
          <div class="instrument-name">1{{$t(`frequencyCheck.${frequency_unit}`)}}{{ timeoutSetting.frequency }}次</div>
        </div>

        <!-- 日期卡片容器：橫向排列 -->
        <div class="date-card-container">
          <div
            v-for="timeoutInstrument in timeoutSetting.timeoutInstrument"
            :key="timeoutInstrument.name"
            class="date-card-wrapper"
          >
            <el-card
              class="date-card"
              :body-style="{ padding: '10px 12px' }"
            >
              {{ timeoutInstrument.name }}
            </el-card>
          </div>
          <div
            v-if="timeoutSetting.timeoutInstrument.length == 0"
            class="date-card-wrapper"
          >
            <el-empty
              class="date-card"
              image-size="50"
              description="無"
            />
          </div>
        </div>
      </div>

    </el-card>
  </div>
</template>

<script>
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

export default {
  props:{
    areaData: Array,
    areaList: Array,
  },
  data() {
    return {
      timeoutSettingList: [],
      activeTimeType: 'thisMonth',
      activeTime: [
        new Date(new Date().getFullYear(), new Date().getMonth(), 1, 0, 0, 0, 0),
        new Date(),
      ],
      areafilters: [],
      areafiltersSelection: '',
    };
  },
  watch: {
    areaData(newVal){
      if (newVal) {
        this.loadStation();
      }
    },
    areaList(newVal){
      if (newVal) {
        this.loadArea();
      }
    },
    activeTime(newVal) {
      if (newVal) {
        this.loadStation();
      }
    },
    areafiltersSelection() {
      this.loadStation();
    },
  },
  mounted(){
    this.loadArea();
    this.loadStation();
  },
  methods: {
    setTime(timeType) {
      this.activeTimeType = timeType;
      const now = new Date();

      if (timeType === 'thisMonth') {
        const start = new Date(now.getFullYear(), now.getMonth(), 1, 0, 0, 0, 0); // 本月1號0點
        const end = new Date(); // 現在時間
        this.activeTime = [start, end];
      }

      else if (timeType === 'lastMonth') {
        const start = new Date(now.getFullYear(), now.getMonth() - 1, 1, 0, 0, 0, 0); // 上個月1號0點
        const end = new Date(new Date(now.getFullYear(), now.getMonth(), 1, 0, 0, 0, 0) - 1); // 本月1號0點 - 1ms
        this.activeTime = [start, end];
      }

      else {
        //console.warn(`Unknown timeType: ${timeType}`);
        this.timeType = 'custom';
      }
    },
    loadStation() {
      const currentArea = (this.areaData || []).find(a => a.areaName === this.areafiltersSelection);
      if(!currentArea || !currentArea.stations) return;
      const timeoutSettingTable = {};

      for(let station of currentArea.stations){
        for(let instrument of station.instruments){
          let settingCount = 0;
          for(let timeoutSetting of instrument.timeoutSetting){
            const { settingType, frequency_unit, frequency } = timeoutSetting;
            const timeout_start_date = timeoutSetting.start_date;
            const timeout_end_date   = timeoutSetting.end_date;

            if(!this.isOverlap(
              { start: timeout_start_date, end: timeout_end_date },
              { start: this.activeTime[0], end: this.activeTime[1] },
            )){
              console.log(instrument.name,'的timeoutSetting[',settingCount,']之時間範圍',timeout_start_date,'~',timeout_end_date,'不再啟動時間內');
              continue;
            }
            settingCount++;
            
            if(!timeoutSettingTable[frequency_unit]){
              timeoutSettingTable[frequency_unit] = new Map();
            }
            const key = timeoutSetting.frequency;
            if(!timeoutSettingTable[frequency_unit].get(key)){
              timeoutSettingTable[frequency_unit].set(key, {
                frequency: key,
                instruments: [instrument],
                timeoutInstrument: [],
                checkList: [],
              });
            }
            else timeoutSettingTable[frequency_unit].get(key).instruments.push(instrument);
            
            let start_date = this.activeTime[0] > new Date(timeout_start_date) ? this.toLocalDateOnly(this.activeTime[0]) : timeout_start_date;
            let end_date   = this.activeTime[1] < new Date(timeout_end_date) ? this.toLocalDateOnly(this.activeTime[1]) : timeout_end_date;
            let outputs_range = this.filterDatesBetween(instrument.outputs.map(ele=>ele.TIMESTAMP), start_date, end_date);
            let _dateList = [];
            if(frequency_unit === 'week'){
              let weeks = this.buildWeekList(outputs_range, start_date, end_date);
              _dateList = weeks.map(output=>{
                let isMet = output.count >= frequency;
                return {
                  type: 'range',
                  start_date: output.dates[0],
                  end_date:   output.dates[output.dates.length - 1],
                  background: isMet ? 'bg-white' : 'bg-red',
                  tip: isMet ? `於${output.includesDates}進行監測` : '期間內未滿足監測頻率',
                  isFrequencyMet: isMet,
                };
              });
            }
            else if(frequency_unit ==='month'){
              let months = this.buildMonthList(outputs_range, start_date, end_date);
              _dateList = months.map(output=>{
                let isMet = output.count >= frequency;
                return {
                  type: 'range',
                  start_date: output.start,
                  end_date:   output.end,
                  background: isMet ? 'bg-white' : 'bg-red',
                  tip: isMet ? `於${output.includesDates}進行監測` : '期間內未更新',
                  isFrequencyMet: isMet,
                };
              });
            }
            else{
              let count = 0;
              for (let cur = new Date(start_date); cur <= new Date(end_date); cur = this.addDays(cur, 1)){
                let now_output = outputs_range[count];
                let isMet = cur == new Date(now_output);
                if(isMet) count++;
                _dateList.push({
                  type: 'day',
                  start_date: cur,
                  end_date:   cur,
                  background: isMet ? 'bg-white' : 'bg-red',
                  tip: isMet ? `於${now_output}進行監測` : `${now_output}未更新`,
                  isFrequencyMet: isMet,
                });
              }
            }

            timeoutSettingTable[frequency_unit].get(key).checkList.push(_dateList);

            const inInstrumentTimeout = _dateList.some(obj => !obj.isFrequencyMet);
            if(inInstrumentTimeout){
              timeoutSettingTable[frequency_unit].get(key).timeoutInstrument.push(instrument);
            }
          }
        }
      }

      this.timeoutSettingList = Object.entries(timeoutSettingTable);
    },

    loadArea() {
      if(!this.areaList || this.areaList.length == 0) return;

      this.areafilters = this.areaList.map(ele=>{
        return {
          areaName: ele,
          //select: false,
        };
      });

      //this.areafilters[0].select = true;
      this.areafiltersSelection = this.areafilters[0].areaName;
    },

    /**
     * Node.js: 由日期陣列與起訖時間產生週列表（以星期一為週起始）
     * - 輸入日期可為 'YYYY-MM-DD' 或 Date 物件（可混用）
     * - 週物件包含 dates(一週7天)、monday..sunday 與 count
     */
    buildWeekList(dateArray, startDateInput = undefined, endDateInput = undefined) {
      if (!Array.isArray(dateArray)) {
        throw new Error('dateArray 必須是陣列');
      }

      // ---- 工具函式 (以「本地時區」處理日曆日，避免時間偏移) ----
      const pad2 = (n) => String(n).padStart(2, '0');
      const toYMD = (d) => `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;

      // ---- 正規化輸入日期陣列 ----
      const normalizedDates = dateArray.map(this.toLocalDateOnly);
      // 供計數使用的查表，把每個輸入日期轉成YMD計次數（同日出現多次要各自計數，所以記錄全部清單即可）
      const normalizedYMDs = normalizedDates.map(toYMD);

      // ---- 決定起訖時間 ----
      let startDate = startDateInput ? this.toLocalDateOnly(startDateInput) : undefined;
      let endDate   = endDateInput   ? this.toLocalDateOnly(endDateInput)   : undefined;

      if (!startDate) {
        if (normalizedDates.length === 0) {
          throw new Error('未提供起始時間且日期陣列為空，無法推定起始時間。請提供 startDate 或至少一個日期。');
        }
        // 取陣列中最早日期
        startDate = new Date(Math.min(...normalizedDates.map(d => d.getTime())));
      }
      if (!endDate) {
        const now = new Date();
        endDate = new Date(now.getFullYear(), now.getMonth(), now.getDate()); // 今日
      }

      // 若起始 > 結束，交換或直接回傳空陣列
      if (startDate > endDate) {
        return [];
      }

      // 取覆蓋整段區間的第一個「週一」與最後一個「週日」
      const firstMonday = this.startOfWeekMonday(startDate);
      const lastSunday  = this.addDays(this.startOfWeekMonday(endDate), 6);

      const weeks = [];
      // 以週為步進
      for (let curMon = firstMonday; curMon <= lastSunday; curMon = this.addDays(curMon, 7)) {
        const days = Array.from({ length: 7 }, (_, i) => this.addDays(curMon, i));
        const daysYMD = days.map(toYMD);

        // 統計這一週內出現於輸入日期陣列中的筆數（同日多次出現就多次計）
        let count = 0;
        let includesDates = [];
        for (const y of normalizedYMDs) {
          if (daysYMD.includes(y)) {
            count += 1;
            includesDates.push(y);
          }
        }

        const [mon, tue, wed, thu, fri, sat, sun] = daysYMD;

        weeks.push({
          dates: daysYMD,
          includesDates,
          monday: mon,
          tuesday: tue,
          wednesday: wed,
          thursday: thu,
          friday: fri,
          saturday: sat,
          sunday: sun,
          count,
        });
      }

      // 僅保留與使用者要求的起訖範圍相交的週（題意：輸出的 week list 為介於起訖的所有週）
      // 上面已用 firstMonday/lastSunday 覆蓋整段；如果你想嚴格只要交集，可保留全部（通常需求即為全部）
      return weeks;
    },

    buildMonthList(dateArray, startDateInput = undefined, endDateInput = undefined) {
      if (!Array.isArray(dateArray)) {
        throw new Error('dateArray 必須是陣列');
      }

      // 工具
      const pad2 = (n) => String(n).padStart(2, '0');
      const toYMD = (d) => `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;
      const toYM  = (d) => `${d.getFullYear()}-${pad2(d.getMonth() + 1)}`;

      function startOfMonth(d) {
        return new Date(d.getFullYear(), d.getMonth(), 1);
      }
      function endOfMonth(d) {
        return new Date(d.getFullYear(), d.getMonth() + 1, 0);
      }
      function addMonths(d, months) {
        const nd = new Date(d.getFullYear(), d.getMonth() + months, 1);
        return nd;
      }

      // 正規化輸入
      const normalizedDates = dateArray.map(this.toLocalDateOnly);

      // 起訖決定
      let startDate = startDateInput ? this.toLocalDateOnly(startDateInput) : undefined;
      let endDate   = endDateInput   ? this.toLocalDateOnly(endDateInput)   : undefined;

      if (!startDate) {
        if (normalizedDates.length === 0) {
          throw new Error('未提供起始時間且日期陣列為空，無法推定起始時間。請提供 startDate 或至少一個日期。');
        }
        startDate = new Date(Math.min(...normalizedDates.map(d => d.getTime())));
      }
      if (!endDate) {
        const now = new Date();
        endDate = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      }
      if (startDate > endDate) return [];

      // 取完整月份邊界
      const firstMonth = startOfMonth(startDate);
      const lastMonthEnd = endOfMonth(endDate);
      const lastMonth = startOfMonth(lastMonthEnd);

      // 預先把輸入日期按「YYYY-MM」分組計數（同一天多次出現就多次計）
      const monthCount = new Map(); // key: 'YYYY-MM' → value: includesDates
      for (const d of normalizedDates) {
        const key = toYM(d);
        if(!monthCount.get(key)){
          monthCount.set(key, [d]);
        }
        else monthCount.get(key).push(d);
      }
      // 產生月份清單
      const months = [];
      for (let cur = new Date(firstMonth); cur <= lastMonth; cur = addMonths(cur, 1)) {
        const ym = toYM(cur);
        const start = startOfMonth(cur);
        const end = endOfMonth(cur);
        months.push({
          includesDates: monthCount.get(ym),
          month: ym,                 // 'YYYY-MM'
          start: toYMD(start),       // 該月第一天
          end: toYMD(end),           // 該月最後一天
          count: monthCount.get(ym)?.length || 0,
          dates: Array.from({length: end.getDate()}, (_, i) => toYMD(new Date(cur.getFullYear(), cur.getMonth(), i+1))),
        });
      }

      return months;
    },

    addDays(d, days) {
      const nd = new Date(d);
      nd.setDate(nd.getDate() + days);
      return nd;
    },

    // 以星期一為週起點的週一日期
    // JS: getDay() => 0(日)~6(六)；我們要將星期一視為0
    startOfWeekMonday(d) {
      const dow = d.getDay();                  // 0(日)~6(六)
      const shift = (dow + 6) % 7;             // 週一=0, 週二=1, ... 週日=6
      return this.addDays(d, -shift);
    },

    /**
     * 傳回 dateList 中介於 start_date 與 end_date（含邊界）的所有日期
     * 支援 'YYYY-MM-DD' 字串或 Date 物件混用
     */
    filterDatesBetween(dateList, startDate, endDate) {
      if (!Array.isArray(dateList)) throw new Error('dateList 必須是陣列');

      const start = this.toLocalDateOnly(startDate);
      const end = this.toLocalDateOnly(endDate);

      return dateList
        .map(this.toLocalDateOnly)
        .filter(d => d >= start && d <= end)
        .map(d => d.toISOString().slice(0, 10)); // 輸出成 'YYYY-MM-DD'
    },

    toLocalDateOnly(input) {
      if (input instanceof Date)
        return new Date(input.getFullYear(), input.getMonth(), input.getDate());
      const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(input.trim());
      if (m) return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
      const d = new Date(input);
      if (isNaN(d)) throw new Error(`無法解析日期：${input}`);
      return new Date(d.getFullYear(), d.getMonth(), d.getDate());
    },

    isOverlap(rangeA, rangeB) {
      const startA = new Date(rangeA.start);
      const endA   = new Date(rangeA.end);
      const startB = new Date(rangeB.start);
      const endB   = new Date(rangeB.end);
    
      // 只要 A 的開始 <= B 的結束 且 B 的開始 <= A 的結束，就表示重疊
      return startA <= endB && startB <= endA;
    },

    async exportReport() {
      // 找到你想匯出的區塊
      const element = document.querySelector('.revenue-card');
      if (!element) {
        this.$message.error('找不到要匯出的區塊');
        return;
      }

      // 截圖並轉成PDF
      const canvas = await html2canvas(element, { scale: 2 });
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF('p', 'mm', 'a4');
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = (canvas.height * pageWidth) / canvas.width;
      pdf.addImage(imgData, 'PNG', 0, 0, pageWidth, pageHeight);
      pdf.save(`報表_${new Date().toISOString().slice(0,10)}.pdf`);
    },
  },
};
</script>

<style scoped>
.dashboard-container {
  padding: 24px;
  background-color: #f5f7fa; /* 淺灰色背景 */
  min-height: 100vh;
}

.filter-card {
  border: none;
}

.execute-button-col {
  text-align: right;
}

.revenue-card .instrument-list {
  margin: 18px 18px 20px;
}

.revenue-card :deep(.el-card__header) {
  padding: 16px 20px;
  background: #fafafa;
  border-bottom: 1px solid #f0f2f5;
}
.revenue-card :deep(.el-card__body) {
  padding: 16px 12px;   /* 與卡片 grid 的 gap 視覺協調 */
}

/* 日期卡片容器：橫向排列並允許換行 */
.date-card-container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr)); /* 180 可微調 */
  gap: 12px;  /* 卡片間距 */
}

/* 控制每個日期卡片的外觀 */
.date-card :deep(.el-card__body) {
  padding: 10px 12px;   /* 緊湊一點 */
}
.date-card {
  min-height: 44px;     /* 固定視覺高度，整齊 */
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  line-height: 1.2;
  font-size: 13px;
}

.date-text {
  display: inline-block;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.instrument-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px; /* 與下方卡片群保持距離 */
}

.rule-badges :deep(.el-tag) {
  border-color: #d9e3f7;
  color: #3a62a6;
  background: #f3f7ff;
  font-weight: 500;
}

.instrument-name {
  font-weight: 600;
  margin-bottom: 10px;
  color: #303133;
  border-left: 3px solid #409EFF;
  padding-left: 8px;
}

.bg-red {
  background-color: #ffb4b4; /* 淡紅色 */
  border: 1px solid #f5a2a0;
}

.bg-white {
  background-color: #ffffff;
  border: 1px solid #ebeef5;
}


/* 響應式調整 */
@media (max-width: 768px) {
  .execute-button-col {
    text-align: left;
    margin-top: 15px;
  }
  .time-filters {
    display: flex;
    width: 100%;
  }
  .time-filters .el-button {
    flex-grow: 1;
  }
  .el-date-picker {
    width: 100%;
    margin-left: 0 !important;
    margin-top: 10px;
  }
}
</style>